<form [formGroup]="restrictionsProfileForm">
  <div class="d-flex justify-content-between">
    @if (title()) {
      <h5 class="mt-auto small-caps">{{ title() }}</h5>
    }
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <table class="table table-sm table-list">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr row-checkbox
          [editing]="editing"
          id="allowAccountModification"
          label="Allow Account Modification"
          description="If false, disables account modification. Requires a supervised device. Available in iOS 7 and later.
        <br><small>Default: true</small>">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAccountModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          id="allowActivityContinuation"
          label="Allow Activity Continuation"
          description="If false, disables activity continuation. Available in iOS 8 and later, and macOS 10.15 and later.
        <br><small>Default: true</small>">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowActivityContinuation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prohibits adding friends to Game Center. As of iOS 13, requires a supervised device. Available in iOS 4.2.1 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowAddingGameCenterFriends"
          label="Allow Adding Game Center Friends">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAddingGameCenterFriends"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables AirDrop. Requires a supervised device. Available in iOS 7 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowAirDrop"
          label="Allow AirDrop">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAirDrop"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables incoming AirPlay requests. Requires a supervised device. Available in tvOS 10.2 and later.
        <br><small>Default: true</small>"
          id="allowAirPlayIncomingRequests"
          label="Allow AirPlay Incoming Requests">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAirPlayIncomingRequests"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables AirPrint.  Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowAirPrint"
          label="Allow AirPrint">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAirPrint"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables keychain storage of user name and password for AirPrint. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowAirPrintCredentialsStorage"
          label="Allow AirPrint Credentials Storage">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAirPrintCredentialsStorage"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iBeacon discovery of AirPrint printers, which prevents spurious AirPrint Bluetooth beacons from phishing for network traffic. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowAirPrintiBeaconDiscovery"
          label="Allow AirPrint iBeacon Discovery">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAirPrintiBeaconDiscovery"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables changing settings for cellular data usage for apps. Requires a supervised device. Available in iOS 7 and later.
        <br><small>Default: true</small>"
          id="allowAppCellularDataModification"
          label="Allow App Cellular Data Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAppCellularDataModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents a user from adding any App Clips, and removes any existing App Clips on the device. Requires a supervised device. Available in iOS 14.0 and later.
        <br><small>Default: true</small>"
          id="allowAppClips"
          label="Allow App Clips">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAppClips"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the App Store, and its icon is removed from the Home screen. Users are unable to install or update their apps. In iOS 10 and later, MDM commands can override this restriction. As of iOS 13, this restriction requires a supervised device. Available in iOS 4 and later.
        <br><small>Default: true</small>"
          id="allowAppInstallation"
          label="Allow App Installation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAppInstallation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, limits Apple personalized advertising. Available in iOS 14 and later.
        <br><small>Default: true</small>"
          id="allowApplePersonalizedAdvertising"
          label="Allow Apple Personalized Advertising">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowApplePersonalizedAdvertising"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables removal of apps from an iOS device. Requires a supervised device. Available in iOS 4.2.1 and later.
        <br><small>Default: true</small>"
          id="allowAppRemoval"
          label="Allow App Removal">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAppRemoval"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Siri. Available in iOS 5 and later. Also available for user enrollment.
      <br><small>Default: true</small>"
          id="allowAssistant"
          label="Allow Assistant">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAssistant"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents Siri from querying user-generated content from the web. Requires a supervised device. Available in iOS 7 and later.
        <br><small>Default: true</small>"
          id="allowAssistantUserGeneratedContent"
          label="Allow Assistant User Generated Content">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAssistantUserGeneratedContent"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Siri when the device is locked. This restriction is ignored if the device doesn't have a passcode set. Available in iOS 5.1 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowAssistantWhileLocked"
          label="Allow Assistant While Locked">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAssistantWhileLocked"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables keyboard autocorrection. Requires a supervised device. Available in iOS 8.1.3 and later.
        <br><small>Default: true</small>"
          id="allowAutoCorrection"
          label="Allow Auto Correction">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAutoCorrection"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents automatic downloading of apps purchased on other devices. This setting doesn't affect updates to existing apps. Requires a supervised device. Available in iOS 9 and later.
        <br><small>Default: true</small>"
          id="allowAutomaticAppDownloads"
          label="Allow Automatic App Downloads">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAutomaticAppDownloads"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disallows auto unlock. Available in macOS 10.12 and later, and iOS 14.5 and later.
        <br><small>Default: true</small>"
          id="allowAutoUnlock"
          label="Allow Auto Unlock">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowAutoUnlock"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents modification of Bluetooth settings. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowBluetoothModification"
          label="Allow Bluetooth Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowBluetoothModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, removes the Book Store tab from the Books app. Requires a supervised device. Available in iOS 6 and later.
        <br><small>Default: true</small>"
          id="allowBookstore"
          label="Allow Bookstore">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowBookstore"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, the user can't download Apple Books media that is tagged as erotica. Available in iOS 6 and later, and tvOS 11.3 and later.
        <br><small>Default: true</small>"
          id="allowBookstoreErotica"
          label="Allow Bookstore Erotica">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowBookstoreErotica"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the camera, and its icon is removed from the Home screen. Users are unable to take photographs. This restriction is deprecated on unsupervised devices and will be supervised only in a future release.  Available in iOS 4 and later, and macOS 10.11 and later.
        <br><small>Default: true</small>"
          id="allowCamera"
          label="Allow Camera">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCamera"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, users can't change any settings related to their cellular plan. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowCellularPlanModification"
          label="Allow Cellular Plan Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCellularPlanModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the use of the iMessage with supervised devices. If the device supports text messaging, the user can still send and receive text messages. Requires a supervised device. Available in iOS 5 and later.
        <br><small>Default: true</small>"
          id="allowChat"
          label="Allow Chat">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowChat"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Address Book services. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudAddressBook"
          label="Allow Cloud Addressbook">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudAddressBook"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables backing up the device to iCloud. This restriction is deprecated on unsupervised devices and will be supervised only in a future release. Available in iOS 5 and later.
        <br><small>Default: true</small>"
          id="allowCloudBackup"
          label="Allow Cloud Backup">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudBackup"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Bookmark sync. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudBookmarks"
          label="Allow Cloud Bookmarks">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudBookmarks"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Calendar services. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudCalendar"
          label="Allow Cloud Calendar">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudCalendar"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables cloud desktop and document services. Available in macOS 10.12.4 and later.
        <br><small>Default: true</small>"
          id="allowCloudDesktopAndDocuments"
          label="Allow Cloud Desktop And Documents">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudDesktopAndDocuments"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables document and key-value syncing to iCloud. As of iOS 13, this restriction requires a supervised device. Available in iOS 5 and later, and macOS 10.11 and later.
        <br><small>Default: true</small>"
          id="allowCloudDocumentSync"
          label="Allow Cloud Document Sync">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudDocumentSync"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud keychain synchronization. This restriction is deprecated on unsupervised devices and will be supervised only in a future release. Available in iOS 7 and later, and macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudKeychainSync"
          label="Allow Cloud Keychain Sync">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudKeychainSync"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Mail services. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudMail"
          label="Allow Cloud Mail">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudMail"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Notes services. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudNotes"
          label="Allow Cloud Notes">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudNotes"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Photo Library. Any photos not fully downloaded from iCloud Photo Library to the device are removed from local storage. Available in iOS 9 and later, and macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudPhotoLibrary"
          label="Allow Cloud Photo Library">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudPhotoLibrary"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Private Relay.
        <br><small>Default: true</small>"
          id="allowCloudPrivateRelay"
          label="Allow Cloud Private Relay">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudPrivateRelay"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iCloud Reminder services. Available in macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowCloudReminders"
          label="Allow Cloud Reminders">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowCloudReminders"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables content caching. As of 10.13.4 this is included in the content caching payload. Available in macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowContentCaching"
          label="Allow Content Caching">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowContentCaching"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables QuickPath keyboard. Requires a supervised device. Available in iOS 13 and later.
        <br><small>Default: true</small>"
          id="allowContinuousPathKeyboard"
          label="Allow Continuous Path Keyboard">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowContinuousPathKeyboard"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables definition lookup. Requires a supervised device. Available in iOS 8.1.3 and later.
        <br><small>Default: true</small>"
          id="allowDefinitionLookup"
          label="Allow Definition Lookup">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDefinitionLookup"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents the device name from being changed. Requires a supervised device. Available in iOS 9 and later, and tvOS 11.0 and later.
        <br><small>Default: true</small>"
          id="allowDeviceNameModification"
          label="Allow Device Name Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDeviceNameModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents device from automatically sleeping. Requires a supervised device. Available in tvOS 13 and later.
        <br><small>Default: true</small>"
          id="allowDeviceSleep"
          label="Allow Device Sleep">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDeviceSleep"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents the device from automatically submitting diagnostic reports to Apple. Available in iOS 6 and later, and macOS 10.13 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowDiagnosticSubmission"
          label="Allow Diagnostic Submission">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDiagnosticSubmission"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables changing the diagnostic submission and app analytics settings in the Diagnostics & Usage UI in Settings. Requires a supervised device. Available in iOS 9.3.2 and later.
        <br><small>Default: true</small>"
          id="allowDiagnosticSubmissionModification"
          label="Allow Diagnostic Submission
        Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDiagnosticSubmissionModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disallows dictation input. Requires a supervised device. Available in iOS 10.3 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowDictation"
          label="Allow Dictation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowDictation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the 'Enable Restrictions' option in the Restrictions UI in Settings.
        In iOS 12 or later, if false, disables the 'Enable ScreenTime' option in the ScreenTime UI in Settings and disables ScreenTime if already enabled. Requires a supervised device. Available in iOS 8 and later.

        <br><small>Default: true</small>"
          id="allowEnablingRestrictions"
          label="Allow Enabling Restrictions">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowEnablingRestrictions"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, removes the Trust Enterprise Developer button in Settings > General > Profiles & Device Management, preventing apps from being provisioned by universal provisioning profiles. This restriction applies to free developer accounts. However, it doesn't apply to enterprise app developers who are trusted because their apps were pushed through MDM. It also doesn't revoke previously granted trust. Available in iOS 9 and later.
        <br><small>Default: true</small>"
          id="allowEnterpriseAppTrust"
          label="Allow Enterprise App Trust">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowEnterpriseAppTrust"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables backup of Enterprise books. Available in iOS 8 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowEnterpriseBookBackup"
          label="Allow Enterprise Book Backup">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowEnterpriseBookBackup"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables sync of Enterprise books, notes, and highlights. Available in iOS 8 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowEnterpriseBookMetadataSync"
          label="Allow Enterprise Book Metadata Sync">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowEnterpriseBookMetadataSync"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the Erase All Content And Settings option in the Reset UI. Requires a supervised device. Available in iOS 8 and later, and macOS 12 and later.
        <br><small>Default: true</small>"
          id="allowEraseContentAndSettings"
          label="Allow Erase Content And Settings">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowEraseContentAndSettings"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables modifications to carrier plan related settings (only available on select carriers). Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowESIMModification"
          label="Allow ESIM Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowESIMModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, hides explicit music or video content purchased from the iTunes Store. Explicit content is marked as such by content providers, such as record labels, when sold through the iTunes Store. As of iOS 13, requires a supervised device. Available in iOS 4 and later, and tvOS 11.3 and later.
        <br><small>Default: true</small>"
          id="allowExplicitContent"
          label="Allow Explicit Content">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowExplicitContent"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents connecting to network drives in the Files app. Requires a supervised device. Available in iOS 13.1 and later.
        <br><small>Default: true</small>"
          id="allowFilesNetworkDriveAccess"
          label="Allow Files Network Drive Access">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFilesNetworkDriveAccess"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents connecting to any connected USB devices in the Files app. Requires a supervised device. Available in iOS 13.1 and later.
        <br><small>Default: true</small>"
          id="allowFilesUSBDriveAccess"
          label="Allow Files USB Drive Access">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFilesUSBDriveAccess"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Find My Device in the Find My app. Requires a supervised device. Available in iOS 13 and later.
        <br><small>Default: true</small>"
          id="allowFindMyDevice"
          label="Allow Find My Device">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFindMyDevice"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Find My Friends in the Find My app. Requires a supervised device. Available in iOS 13 and later.
        <br><small>Default: true</small>"
          id="allowFindMyFriends"
          label="Allow Find My Friends">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFindMyFriends"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables changes to Find My Friends. Requires a supervised device. Available in iOS 7 and later.
        <br><small>Default: true</small>"
          id="allowFindMyFriendsModification"
          label="Allow Find My Friends Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFindMyFriendsModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents Touch ID or Face ID from unlocking a device. Available in iOS 7 and later, and macOS 10.12.4 and later.
        <br><small>Default: true</small>"
          id="allowFingerprintForUnlock"
          label="Allow Fingerprint For Unlock">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFingerprintForUnlock"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents the user from modifying Touch ID or Face ID. Requires a supervised device. Available in iOS 8.3 and later.
        <br><small>Default: true</small>"
          id="allowFingerprintModification"
          label="Allow Fingerprint Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowFingerprintModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Game Center, and its icon is removed from the Home screen. Requires a supervised device. Available in iOS 6 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowGameCenter"
          label="Allow Game Center">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowGameCenter"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables global background fetch activity when an iOS phone is roaming. Available in iOS 4 and later.
        <br><small>Default: true</small>"
          id="allowGlobalBackgroundFetchWhenRoaming"
          label="Allow Global Background Fetch When Roaming">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowGlobalBackgroundFetchWhenRoaming"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables host pairing with the exception of the supervision host. If no supervision host certificate has been configured, all pairing is disabled. Host pairing lets the administrator control if an iOS device can pair with a host Mac or PC. Requires a supervised device. Available in iOS 7 and later.
        <br><small>Default: true</small>"
          id="allowHostPairing"
          label="Allow Host Pairing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowHostPairing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prohibits in-app purchasing. Available in iOS 4 and later.
      <br><small>Default: true</small>"
          id="allowInAppPurchases"
          label="Allow In App Purchases">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowInAppPurchases"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the iTunes Music Store, and its icon is removed from the Home screen. Users cannot preview, purchase, or download content.
        As of iOS 13, requires a supervised device. Available in iOS 4 and later.

        <br><small>Default: true</small>"
          id="allowiTunes"
          label="Allow iTunes">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowiTunes"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables iTunes file sharing services. Available in macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowiTunesFileSharing"
          label="Allow iTunes File Sharing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowiTunesFileSharing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables keyboard shortcuts. Requires a supervised device. Available in iOS 9 and later.
        <br><small>Default: true</small>"
          id="allowKeyboardShortcuts"
          label="Allow Keyboard Shortcuts">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowKeyboardShortcuts"></ml-yes-no-icon>
      </tr>
      <tr id="allowListedAppBundleIDs">
        <th>
          <label for="allowListedAppBundleIDs"
                 class="col-form-label"
                 i18n>Allow listed App Bundle IDs</label>
        </th>
        <td class="align-middle">
          @if (!editing) {
            <ul class="list-unstyled mb-0">
              @for (
            allowListedAppBundleIDs of restrictionsProfile()?.allowListedAppBundleIDs;
            track allowListedAppBundleIDs
            ) {
                <li>
                  {{ allowListedAppBundleIDs }}
                </li>
              }
            </ul>
          } @else {
            <button class="btn btn-outline-primary border-0"
                    (click)="addAllowListedAppBundleIDs()">
              <fa-icon icon="plus"></fa-icon>
            </button>
          }
        </td>
        <td>
          If present, this property allows only bundle IDs listed in the array to be shown or launchable. Include the
          value com.apple.webapp to allow all webclips. Requires a supervised device. Available in iOS 9.3 and later,
          and tvOS 11.0 and later.
        </td>
      </tr>
      @if (editing) {
        <ng-container formArrayName="allowListedAppBundleIDs">
          @for (
        allowListedAppBundleID of allowListedAppBundleIDs.controls;
        track allowListedAppBundleID;
        let i = $index
        ) {
            <tr>
              <td></td>
              <td class="align-middle"
                  colspan="2">
                <div class="d-flex">
                  <input type="text"
                         class="form-control"
                         [formControlName]="i"
                         [class.is-invalid]="
                      allowListedAppBundleIDs.controls[i].invalid && allowListedAppBundleIDs.controls[i].touched
                    " />
                  <button class="btn btn-outline-primary border-0 d-block"
                          (click)="deleteAllowListedAppBundleIDs(i)">
                    <fa-icon icon="times"></fa-icon>
                  </button>
                </div>
                @if (allowListedAppBundleIDs.controls[i].invalid && allowListedAppBundleIDs.controls[i].touched) {
                  <div class="invalid-feedback">
                    @if (allowListedAppBundleIDs.controls[i]?.errors?.required) {
                      <div i18n>A bundle id is required.</div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </ng-container>
      }
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents Control Center from appearing on the Lock screen. Available in iOS 7 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowLockScreenControlCenter"
          label="Allow Lock Screen Control Center">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowLockScreenControlCenter"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the Notifications history view on the lock screen, so users can't view past notifications. However, they can still see notifications when they arrive. Available in iOS 7 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowLockScreenNotificationsView"
          label="Allow Lock Screen Notifications View">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowLockScreenNotificationsView"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the Today view in Notification Center on the lock screen. Available in iOS 7 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowLockScreenTodayView"
          label="Allow Lock Screen Today View">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowLockScreenTodayView"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents managed apps from using iCloud sync. Available in iOS 8 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowManagedAppsCloudSync"
          label="Allow Managed Apps Cloud Sync">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowManagedAppsCloudSync"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, managed apps can write contacts to unmanaged contacts accounts. If allowOpenFromManagedToUnmanaged is true, this restriction has no effect. If this restriction is set to true, you must install the payload through MDM. Available in iOS 12 and later.
        <br><small>Default: false</small>"
          id="allowManagedToWriteUnmanagedContacts"
          label="Allow Managed To Write Unmaged Contacts">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowManagedToWriteUnmanagedContacts"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prohibits multiplayer gaming. Requires a supervised device. Available in iOS 4.1 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowMultiplayerGaming"
          label="Allow Multiplayer Gaming">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowMultiplayerGaming"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the Music service, and the Music app reverts to classic mode. Requires a supervised device. Available in iOS 9.3 and later, and macOS 10.12 and later.
        <br><small>Default: true</small>"
          id="allowMusicService"
          label="Allow Music Service">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowMusicService"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables News. Requires a supervised device. Available in iOS 9 and later.
        <br><small>Default: true</small>"
          id="allowNews"
          label="Allow News">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowNews"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables NFC. Requires a supervised device. Available in iOS 14.2 and later.
        <br><small>Default: true</small>"
          id="allowNFC"
          label="Allow NFC">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowNFC"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables modification of notification settings. Requires a supervised device. Available in iOS 9.3 and later.
        <br><small>Default: true</small>"
          id="allowNotificationsModification"
          label="Allow Notifications Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowNotificationsModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, documents in managed apps and accounts only open in other managed apps and accounts. Available in iOS 7 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowOpenFromManagedToUnmanaged"
          label="Allow Open From Managed To Unmanaged">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowOpenFromManagedToUnmanaged"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, documents in unmanaged apps and accounts only open in other unmanaged apps and accounts. Available in iOS 7 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowOpenFromUnmanagedToManaged"
          label="Allow Open From Unmanaged To Managed">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowOpenFromUnmanagedToManaged"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables over-the-air PKI updates. Setting this restriction to false doesn't disable CRL and OCSP checks.  Available in iOS 7 and later.
        <br><small>Default: true</small>"
          id="allowOTAPKIUpdates"
          label="Allow OTAPKIUpdates">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowOTAPKIUpdates"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables pairing with an Apple Watch. Any currently paired Apple Watch is unpaired and the watch's content is erased. Requires a supervised device. Available in iOS 9 and later.
        <br><small>Default: true</small>"
          id="allowPairedWatch"
          label="Allow Paired Watch">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPairedWatch"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, hides Passbook notifications from the lock screen. Available in iOS 6 and later.
        <br><small>Default: true</small>"
          id="allowPassbookWhileLocked"
          label="Allow Passbook While Locked">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPassbookWhileLocked"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents the device passcode from being added, changed, or removed.
        This restriction is ignored by Shared iPads. Requires a supervised device. Available in iOS 9 and later, and macOS 10.13 and later.

        <br><small>Default: true</small>"
          id="allowPasscodeModification"
          label="Allow Passcode Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPasscodeModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the AutoFill Passwords feature in iOS (with Keychain and third-party password managers) and the user isn't prompted to use a saved password in Safari or in apps.
        This restriction also disables Automatic Strong Passwords, and strong passwords are no longer suggested to users.

        It does not prevent AutoFill for contact info and credit cards in Safari.

        Requires a supervised device. Available in iOS 12 and later, and macOS 10.14 and later.

        <br><small>Default: true</small>"
          id="allowPasswordAutoFill"
          label="Allow Password Auto Fill">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPasswordAutoFill"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables requesting passwords from nearby devices. Requires a supervised device. Available in iOS 12 and later, macOS 10.14 and later, and tvOS 12 and later.
        <br><small>Default: true</small>"
          id="allowPasswordProximityRequests"
          label="Allow Password Proximity Requests">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPasswordProximityRequests"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables sharing passwords with the Airdrop Passwords feature. Requires a supervised device. Available in iOS 12 and later, and macOS 10.14 and later.
        <br><small>Default: true</small>"
          id="allowPasswordSharing"
          label="Allow Password Sharing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPasswordSharing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables modifications of the personal hotspot setting. Requires a supervised device. Available in iOS 12.2 and later.
        <br><small>Default: true</small>"
          id="allowPersonalHotspotModification"
          label="Allow Personal Hotspot Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPersonalHotspotModification"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Photo Stream. Available in iOS 5 and later.
        <br><small>Default: true</small>"
          id="allowPhotoStream"
          label="Allow Photo Stream">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPhotoStream"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables podcasts. Requires a supervised device. Available in iOS 8 and later.
        <br><small>Default: true</small>"
          id="allowPodcasts"
          label="Allow Podcasts">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPodcasts"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables predictive keyboards. Requires a supervised device. Available in iOS 8.1.3 and later.
        <br><small>Default: true</small>"
          id="allowPredictiveKeyboard"
          label="Allow Predictive Keyboard">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowPredictiveKeyboard"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the prompt to set up new devices that are nearby. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowProximitySetupToNewDevice"
          label="Allow Proximity Setup To New Device">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowProximitySetupToNewDevice"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Apple Music Radio. Requires a supervised device. Available in iOS 9.3 and later.
        <br><small>Default: true</small>"
          id="allowRadioService"
          label="Allow Radio Service">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowRadioService"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables pairing Apple TV for use with the Remote app or Control Center widget. Requires a supervised device. Available in tvOS 10.2 and later.
        <br><small>Default: true</small>"
          id="allowRemoteAppPairing"
          label="Allow Remote App Pairing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowRemoteAppPairing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables remote screen observation by the Classroom app. Nest this key beneath allowScreenShot as a subrestriction. If allowScreenShot is set to false, the Classroom app doesn't observe remote screens. Required a supervised device until iOS 13 and macOS 10.15. Available in iOS 12 and later, and macOS 10.14.4 and later.
        <br><small>Default: true</small>"
          id="allowRemoteScreenObservation"
          label="Allow Remote Screen Observation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowRemoteScreenObservation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the Safari web browser app, and its icon is removed from the Home screen. This setting also prevents users from opening web clips. As of iOS 13, requires a supervised device. Available in iOS 4 and later.
        <br><small>Default: true</small>"
          id="allowSafari"
          label="Allow Safari">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSafari"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables saving a screenshot of the display and capturing a screen recording. It also disables the Classroom app from observing remote screens. Available in iOS 4 and later, and macOS 10.14.4 and later. Also available for user enrollment.
        <br><small>Default: true</small>"
          id="allowScreenShot"
          label="Allow Screen Shot">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowScreenShot"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, temporary sessions are not available on Shared iPad. Available in iOS 13.4 and later.
        <br><small>Default: true</small>"
          id="allowSharedDeviceTemporarySession"
          label="Allow Shared Device Temporary Session">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSharedDeviceTemporarySession"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Shared Photo Stream. Available in iOS 6 and later.
        <br><small>Default: true</small>"
          id="allowSharedStream"
          label="Allow Shared Stream">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSharedStream"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables keyboard spell-check. Requires a supervised device. Available in iOS 8.1.3 and later.
        <br><small>Default: true</small>"
          id="allowSpellCheck"
          label="Allow Spell Check">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSpellCheck"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Spotlight Internet search results in Siri Suggestions. Available in iOS 8 and later, and macOS 10.11 and later.
        <br><small>Default: true</small>"
          id="allowSpotlightInternetResults"
          label="Allow Spotlight Internet Results">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSpotlightInternetResults"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the removal of system apps from the device. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowSystemAppRemoval"
          label="Allow System App Removal">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowSystemAppRemoval"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the App Store, and its icon is removed from the Home screen. However, users may continue to use host apps (iTunes, Configurator) to install or update their apps.
        In iOS 10 and later, MDM commands can override this restriction. Requires a supervised device. Available in iOS 9 and later.

        <br><small>Default: true</small>"
          id="allowUIAppInstallation"
          label="Allow UIApp Installation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUIAppInstallation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prohibits the user from installing configuration profiles and certificates interactively. Requires a supervised device. Available in iOS 6 and later.
        <br><small>Default: true</small>"
          id="allowUIConfigurationProfileInstallation"
          label="Allow UIConfiguration Profile
            Installation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUIConfigurationProfileInstallation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, unmanaged apps can read from managed contacts accounts. If allowOpenFromManagedToUnmanaged is true, this restriction has no effect. If this restriction is set to true, you must install the payload through MDM. Available in iOS 12 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="allowUnmanagedToReadManagedContacts"
          label="Allow Unmanaged To Read Managed Contacts">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUnmanagedToReadManagedContacts"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, allows devices to be booted into recovery by an unpaired device. Requires a supervised device. Available in iOS 14.5 and later.
        <br><small>Default: false</small>"
          id="allowUnpairedExternalBootToRecovery"
          label="Allow Unpaired External Boot To Recovery">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUnpairedExternalBootToRecovery"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, automatically rejects untrusted HTTPS certificates without prompting the user. Available in iOS 5 and later.
        <br><small>Default: true</small>"
          id="allowUntrustedTLSPrompt"
          label="Allow Untrusted TLSPrompt">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUntrustedTLSPrompt"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, allows the device to always connect to USB accessories while locked. Requires a supervised device. Available in iOS 11.4.1 and later.
      <br><small>Default: true</small>"
          id="allowUSBRestrictedMode"
          label="Allow USB Restricted Mode">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowUSBRestrictedMode"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, hides the FaceTime app. As of iOS 13, requires a supervised device. Available in iOS 4 and later.
        <br><small>Default: true</small>"
          id="allowVideoConferencing"
          label="Allow Video Conferencing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowVideoConferencing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables voice dialing if the device is locked with a passcode. Available in iOS 4 and later.
        <br><small>Default: true</small>"
          id="allowVoiceDialing"
          label="Allow Voice Dialing">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowVoiceDialing"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables the creation of VPN configurations. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: true</small>"
          id="allowVPNCreation"
          label="Allow VPN Creation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowVPNCreation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, prevents wallpaper from being changed. Requires a supervised device. Available in iOS 9 and later, and macOS 10.13 and later.
        <br><small>Default: true</small>"
          id="allowWallpaperModification"
          label="Allow Wallpaper Modification">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowWallpaperModification"></ml-yes-no-icon>
      </tr>
      <tr id="autonomousSingleAppModePermittedAppIDs">
        <th>
          <label for="autonomousSingleAppModePermittedAppIDs"
                 class="col-form-label"
                 i18n>Autonomous Single App Mode Permitted App IDs</label>
        </th>
        <td class="align-middle">
          @if (!editing) {
            <ul class="list-unstyled mb-0">
              @for (
            autonomousSingleAppModePermittedAppIDs of restrictionsProfile()?.autonomousSingleAppModePermittedAppIDs;
            track autonomousSingleAppModePermittedAppIDs
            ) {
                <li>
                  {{ autonomousSingleAppModePermittedAppIDs }}
                </li>
              }
            </ul>
          } @else {
            <button class="btn btn-outline-primary border-0"
                    (click)="addAutonomousSingleAppModePermittedAppIDs()">
              <fa-icon icon="plus"></fa-icon>
            </button>
          }
        </td>
        <td>
          If present, allows apps identified by the bundle IDs listed in the array to autonomously enter Single App
          Mode. Requires a supervised device. Available in iOS 7 and later.
        </td>
      </tr>
      @if (editing) {
        <ng-container formArrayName="autonomousSingleAppModePermittedAppIDs">
          @for (
        autonomousSingleAppModePermittedAppID of autonomousSingleAppModePermittedAppIDs.controls;
        track autonomousSingleAppModePermittedAppID;
        let i = $index
        ) {
            <tr>
              <td></td>
              <td class="align-middle"
                  colspan="2">
                <div class="d-flex">
                  <input type="text"
                         class="flex-grow-1 form-control"
                         [formControlName]="i"
                         [class.is-invalid]="
                      autonomousSingleAppModePermittedAppIDs.controls[i].invalid &&
                      autonomousSingleAppModePermittedAppIDs.controls[i].touched
                    " />
                  <button class="btn btn-outline-primary border-0 d-block"
                          (click)="deleteAutonomousSingleAppModePermittedAppID(i)">
                    <fa-icon icon="times"></fa-icon>
                  </button>
                </div>
                @if (
            autonomousSingleAppModePermittedAppIDs.controls[i].invalid &&
            autonomousSingleAppModePermittedAppIDs.controls[i].touched
            ) {
                  <div class="invalid-feedback">
                    @if (autonomousSingleAppModePermittedAppIDs.controls[i]?.errors?.required) {
                      <div i18n>A bundle id is required.</div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </ng-container>
      }
      <tr id="blockedAppBundleIDs">
        <th>
          <label for="blockedAppBundleIDs"
                 class="col-form-label"
                 i18n>Blocked App Bundle IDs</label>
        </th>
        <td class="align-middle">
          @if (!editing) {
            <ul class="list-unstyled mb-0">
              @for (blockedAppBundleIDs of restrictionsProfile()?.blockedAppBundleIDs; track blockedAppBundleIDs) {
                <li>
                  {{ blockedAppBundleIDs }}
                </li>
              }
            </ul>
          } @else {
            <button class="btn btn-outline-primary border-0"
                    (click)="addBlockedAppBundleIDs()">
              <fa-icon icon="plus"></fa-icon>
            </button>
          }
        </td>
        <td>
          If present, prevents bundle IDs listed in the array from being shown or launchable. Include the value
          com.apple.webapp to restrict all webclips. Requires a supervised device. Available in iOS 9.3 and later, and
          tvOS 11.0 and later.
        </td>
      </tr>
      @if (editing) {
        <ng-container formArrayName="blockedAppBundleIDs">
          @for (blockedAppBundleID of blockedAppBundleIDs.controls; track blockedAppBundleID; let i = $index) {
            <tr>
              <td></td>
              <td class="align-middle"
                  colspan="2">
                <div class="d-flex">
                  <input type="text"
                         class="flex-grow-1 form-control"
                         [formControlName]="i"
                         [class.is-invalid]="
                      blockedAppBundleIDs.controls[i].invalid && blockedAppBundleIDs.controls[i].touched
                    " />
                  <button class="btn btn-outline-primary border-0"
                          (click)="deleteBlockedAppBundleIDs(i)">
                    <fa-icon icon="times"></fa-icon>
                  </button>
                </div>
                @if (blockedAppBundleIDs.controls[i].invalid && blockedAppBundleIDs.controls[i].touched) {
                  <div class="invalid-feedback">
                    @if (blockedAppBundleIDs.controls[i]?.errors?.required) {
                      <div i18n>A bundle id is required.</div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </ng-container>
      }
      <tr id="enforcedFingerprintTimeout">
        <th><label for="enforcedFingerprintTimeout"
                 class="col-form-label">Enforced Fingerprint Timeout</label></th>
        <td class="align-middle">
          @if (editing) {
            <input class="form-control"
                   type="number"
                   min="0"
                   id="enforcedFingerprintTimeout"
                   formControlName="enforcedFingerprintTimeout" />
          } @else {
            {{ restrictionsProfile()?.enforcedFingerprintTimeout }}<br />
            <small>seconds</small>
          }
        </td>
        <td>
          The value, in seconds, after which the fingerprint unlock will require a password to authenticate. The default
          value is 48 hours.
          <br /><small>Default: 172800</small>
        </td>
      </tr>
      <tr id="enforcedSoftwareUpdateDelay">
        <th><label for="enforcedSoftwareUpdateDelay"
                 class="col-form-label">Enforced Software Update Delay</label></th>
        <td class="align-middle">
          @if (editing) {
            <input class="form-control"
                   type="number"
                   min="1"
                   max="90"
                   id="enforcedSoftwareUpdateDelay"
                   formControlName="enforcedSoftwareUpdateDelay" />
          } @else {
            {{ restrictionsProfile()?.enforcedSoftwareUpdateDelay }}<br />
            <small>days</small>
          }
        </td>
        <td>
          Sets how many days to delay a software update on the device. With this restriction in place, the user doesn't
          see a software update until the specified number of days after the software update release date. This value is
          used by forceDelayedAppSoftwareUpdates and forceDelayedSoftwareUpdates. Requires a supervised device in iOS
          and tvOS.<br />
          <br />
          Available in iOS 11.3 and later, macOS 10.13.4 and later, and tvOS 12.2 and later.<br />
          <br />
          <small>Default: 30</small><br />
          <small>Minimum Value: 1</small><br />
          <small>Maximum Value: 90</small>
        </td>
      </tr>
      <tr id="enforcedSoftwareUpdateMajorOSDeferredInstallDelay">
        <th>
          <label for="enforcedSoftwareUpdateMajorOSDeferredInstallDelay"
                 class="col-form-label">Enforced Software Update Major OS Deferred Install Delay</label>
        </th>
        <td class="align-middle">
          @if (editing) {
            <input class="form-control"
                   type="number"
                   min="1"
                   max="90"
                   id="enforcedSoftwareUpdateMajorOSDeferredInstallDelay"
                   formControlName="enforcedSoftwareUpdateMajorOSDeferredInstallDelay" />
          } @else {
            {{ restrictionsProfile()?.enforcedSoftwareUpdateMajorOSDeferredInstallDelay }}<br />
            <small>days</small>
          }
        </td>
        <td>
          This restriction allows the admin to set how many days to delay a major software update on the device. When
          this restriction is in place the user sees a software update only after the specified delay after the release
          of the software update. This value controls the delay for forceDelayedMajorSoftwareUpdates. Available in macOS
          11.3 and later.<br />
          <br />
          <small>Default: 30</small><br />
          <small>Minimum Value: 1</small><br />
          <small>Maximum Value: 90</small>
        </td>
      </tr>
      <tr id="enforcedSoftwareUpdateMinorOSDeferredInstallDelay">
        <th>
          <label for="enforcedSoftwareUpdateMinorOSDeferredInstallDelay"
                 class="col-form-label">Enforced Software Update Minor OS Deferred Install Delay</label>
        </th>
        <td class="align-middle">
          @if (editing) {
            <input class="form-control"
                   type="number"
                   min="1"
                   max="90"
                   id="enforcedSoftwareUpdateMinorOSDeferredInstallDelay"
                   formControlName="enforcedSoftwareUpdateMinorOSDeferredInstallDelay" />
          } @else {
            {{ restrictionsProfile()?.enforcedSoftwareUpdateMinorOSDeferredInstallDelay }}<br />
            <small>days</small>
          }
        </td>
        <td>
          This restriction allows the admin to set how many days to delay a minor OS software update on the device. When
          this restriction is in place the user see a software update only after the specified delay after the release
          of the software update. This value controls the delay for forceDelayedSoftwareUpdates. Available in macOS 11.3
          and later.<br />
          <br />
          <small>Default: 30</small><br />
          <small>Minimum Value: 1</small><br />
          <small>Maximum Value: 90</small>
        </td>
      </tr>
      <tr id="enforcedSoftwareUpdateNonOSDeferredInstallDelay">
        <th>
          <label for="label"
                 class="col-form-label">Enforced Software Update Non OS Deferred Install Delay</label>
        </th>
        <td class="align-middle">
          @if (editing) {
            <input class="form-control"
                   type="number"
                   min="1"
                   max="90"
                   id="enforcedSoftwareUpdateNonOSDeferredInstallDelay"
                   formControlName="enforcedSoftwareUpdateNonOSDeferredInstallDelay" />
          } @else {
            {{ restrictionsProfile()?.enforcedSoftwareUpdateNonOSDeferredInstallDelay }} days
          }
        </td>
        <td>
          This restriction allows the admin to set how many days to delay an app software update on the device. When
          this restriction is in place the user sees a non-OS software update only after the specified delay after the
          release of the software. This value controls the delay for forceDelayedAppSoftwareUpdates. Available in macOS
          11.3 and later.<br />
          <br />
          <small>Default: 30</small><br />
          <small>Minimum Value: 1</small><br />
          <small>Maximum Value: 90</small>
        </td>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, causes AirDrop to be considered an unmanaged drop target. Available in iOS 9 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="forceAirDropUnmanaged"
          label="Force Air Drop Unmanaged">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAirDropUnmanaged"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, forces all devices sending AirPlay requests to this device to use a pairing password. Available in Apple TV Software 6.2 and later. This key isn't supported in tvOS 10.2 and later. Use the AirPlay Security Payload instead.
        <br><small>Default: false</small>"
          id="forceAirPlayIncomingRequestsPairingPassword"
          label="Force Air Play Incoming Requests Pairing Password">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAirPlayIncomingRequestsPairingPassword"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, forces all devices receiving AirPlay requests from this device to use a pairing password. Available in iOS 7.1 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="forceAirPlayOutgoingRequestsPairingPassword"
          label="Force Air Play Outgoing Requests Pairing Password">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAirPlayOutgoingRequestsPairingPassword"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, requires trusted certificates for TLS printing communication. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: false</small>"
          id="forceAirPrintTrustedTLSRequirement"
          label="Force Air Print Trusted
            TLSRequirement">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAirPrintTrustedTLSRequirement"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, forces the use of the profanity filter assistant. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: false</small>"
          id="forceAssistantProfanityFilter"
          label="Force Assistant Profanity Filter">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAssistantProfanityFilter"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, the user must authenticate before passwords or credit card information can be autofilled in Safari and Apps. If this restriction isn't enforced, the user can toggle this feature in Settings. Only supported on devices with Face ID or Touch ID. Requires a supervised device. Available in iOS 11 and later.
        <br><small>Default: false</small>"
          id="forceAuthenticationBeforeAutoFill"
          label="Force Authentication Before Auto Fill">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAuthenticationBeforeAutoFill"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, enables the Set Automatically feature in Date & Time and can't be disabled by the user.  The device's time zone is updated only when the device can determine its location using a cellular connection or Wi-Fi with location services enabled. Requires a supervised device. Available in iOS 12 and later, and tvOS 12.2 and later.
        <br><small>Default: false</small>"
          id="forceAutomaticDateAndTime"
          label="Force Automatic Date And Time">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceAutomaticDateAndTime"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, automatically gives permission to the teacher's requests without prompting the student. Requires a supervised device. Available in iOS 11 and later, and macOS 10.14.4 and later.
        <br><small>Default: false</small>"
          id="forceClassroomAutomaticallyJoinClasses"
          label="Force Classroom Automatically Join Classes">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceClassroomAutomaticallyJoinClasses"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, a student enrolled in an unmanaged course through Classroom requests permission from the teacher when attempting to leave the course. Requires a supervised device. Available in iOS 11.3 and later, and macOS 10.14.4 and later.
        <br><small>Default: false</small>"
          id="forceClassroomRequestPermissionToLeaveClasses"
          label="Force Classroom Request
            Permission To Leave Classes">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceClassroomRequestPermissionToLeaveClasses"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, allows the teacher to lock apps or the device without prompting the student. Requires a supervised device. Available in iOS 11 and later, and macOS 10.14.4 and later.
        <br><small>Default: false</small>"
          id="forceClassroomUnpromptedAppAndDeviceLock"
          label="Force Classroom Unprompted App And Device Lock">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceClassroomUnpromptedAppAndDeviceLock"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true and ScreenObservationPermissionModificationAllowed is also true in the Education payload, a student enrolled in a managed course via the Classroom app automatically gives permission to that course teacher's requests to observe the student's screen without prompting the student. Requires a supervised device. Available in iOS 11 and later, and macOS 10.14.4 and later.
        <br><small>Default: false</small>"
          id="forceClassroomUnpromptedScreenObservation"
          label="Force Classroom Unprompted Screen Observation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceClassroomUnpromptedScreenObservation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, delays user visibility of non-OS Software Updates. Requires a supervised device.
        Visibility of Operating System updates is controlled through forceDelayedSoftwareUpdates.

        The delay is 30 days unless enforcedSoftwareUpdateDelay is set to another value.

        Available in macOS 11 and later.

        <br><small>Default: false</small>"
          id="forceDelayedAppSoftwareUpdates"
          label="Force Delayed App Software Updates">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceDelayedAppSoftwareUpdates"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If set to true, delays user visibility of major OS Software Updates.
        Available in macOS 11.3 and later.

        <br><small>Default: false</small>"
          id="forceDelayedMajorSoftwareUpdates"
          label="Force Delayed Major Software Updates">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceDelayedMajorSoftwareUpdates"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, delays user visibility of software updates. In macOS, seed build updates are allowed, without delay. Requires a supervised device in iOS and tvOS.
        The delay is 30 days unless enforcedSoftwareUpdateDelay is set to another value.

        Available in iOS 11.3 and later, macOS 10.13 and later, and tvOS 12.2 and later.

        <br><small>Default: false</small>"
          id="forceDelayedSoftwareUpdates"
          label="Force Delayed Software Updates">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceDelayedSoftwareUpdates"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, encrypts all backups. Available in iOS 4 and later. Also available for user enrollment.
      <br><small>Default: false</small>"
          id="forceEncryptedBackup"
          label="Force Encrypted Backup">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceEncryptedBackup"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, forces the user to enter their iTunes password for each transaction. Available in iOS 6 and later.
        <br><small>Default: false</small>"
          id="forceITunesStorePasswordEntry"
          label="Force iTunes Store Password Entry">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceITunesStorePasswordEntry"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, limits ad tracking. Available in iOS 7 and later.
        <br><small>Default: false</small>"
          id="forceLimitAdTracking"
          label="Force Limit Ad Tracking">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceLimitAdTracking"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, disables connections to Siri servers for the purposes of dictation. Available in iOS 14.5 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="forceOnDeviceOnlyDictation"
          label="Force On Device Only Dictation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceOnDeviceOnlyDictation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, disables connections to Siri servers for the purposes of dictation. Available in iOS 14.5 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="forceOnDeviceOnlyTranslation"
          label="Force On Device Only Translation">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceOnDeviceOnlyTranslation"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, forces a paired Apple Watch to use Wrist Detection. Available in iOS 8.2 and later. Also available for user enrollment.
        <br><small>Default: false</small>"
          id="forceWatchWristDetection"
          label="Force Watch Wrist Detection">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceWatchWristDetection"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, limits device to only join Wi-Fi networks set-up via configuration profile. Requires a supervised device. Available in iOS 14.5 and later.
        <br><small>Default: false</small>"
          id="forceWiFiToAllowedNetworksOnly"
          label="Force WiFi To Allowed Networks Only">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceWiFiToAllowedNetworksOnly"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, prevents Wi-Fi from being turned off in Settings or Control Center, even by entering or leaving Airplane Mode. It doesn't prevent selecting which Wi-Fi network to use. Requires a supervised device. Available in iOS 13.0 and later.
        <br><small>Default: false</small>"
          id="forceWiFiPowerOn"
          label="Force WiFi To Allowed Networks Only">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceWiFiPowerOn"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="Deprecated  Use forceWiFiToAllowedNetworksOnly instead.
        <br><small>Default: false</small>"
          id="forceWiFiWhitelisting"
          label="Force Wi Fi Whitelisting">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.forceWiFiWhitelisting"></ml-yes-no-icon>
      </tr>
      <tr id="ratingApps">
        <th><label for="ratingApps"
                 class="col-form-label"
                 i18n>Rating Apps</label></th>
        <td class="align-middle">
          @if (editing) {
            <select class="form-select"
                    id="ratingApps"
                    formControlName="ratingApps">
              <option value=""
                      selected
                      hidden>Choose here</option>
              <option value="1000">All</option>
              <option value="600">17+</option>
              <option value="300">12+</option>
              <option value="200">9+</option>
              <option value="100">4+</option>
              <option value="0">None</option>
            </select>
          } @else {
            @switch (restrictionsProfile()?.ratingApps) {
              @case (1000) {
                <label for="ratingApps"
                       i18n>All</label>
              }
              @case (600) {
                <label for="ratingApps"
                       i18n>17+</label>
              }
              @case (300) {
                <label for="ratingApps"
                       i18n>12+</label>
              }
              @case (200) {
                <label for="ratingApps"
                       i18n>9+</label>
              }
              @case (100) {
                <label for="ratingApps"
                       i18n>4+</label>
              }
              @case (0) {
                <label for="ratingApps"
                       i18n>None</label>
              }
            }
          }
        </td>
        <td>
          The maximum level of app content allowed on the device. Available in iOS 4 and later, and tvOS 11.3 and
          later.<br />
          Possible values (with the US description of the rating level):<br />
          <br />
          1000: All<br />
          600: 17+<br />
          300: 12+<br />
          200: 9+<br />
          100: 4+<br />
          0: None<br />
          <small>Default: 1000</small><br />
          <small>Minimum Value: 0</small><br />
          <small>Maximum Value: 1000</small>
        </td>
      </tr>

      <tr id="ratingMovies">
        <th><label for="ratingMovies"
                 class="col-form-label"
                 i18n>Rating Movies</label></th>
        <td class="align-middle">
          @if (editing) {
            <select class="form-select"
                    id="ratingMovies"
                    formControlName="ratingMovies">
              <option value=""
                      selected
                      hidden>Choose here</option>
              <option value="1000">All</option>
              <option value="500">NC-17</option>
              <option value="400">R</option>
              <option value="300">PG-13</option>
              <option value="200">PG</option>
              <option value="100">G</option>
              <option value="0">None</option>
            </select>
          } @else {
            @switch (restrictionsProfile()?.ratingMovies) {
              @case (1000) {
                <label for="ratingMovies"
                       i18n>All</label>
              }
              @case (500) {
                <label for="ratingMovies"
                       i18n>NC-17</label>
              }
              @case (400) {
                <label for="ratingMovies"
                       i18n>R</label>
              }
              @case (300) {
                <label for="ratingMovies"
                       i18n>PG-13</label>
              }
              @case (200) {
                <label for="ratingMovies"
                       i18n>PG</label>
              }
              @case (100) {
                <label for="ratingMovies"
                       i18n>G</label>
              }
              @case (0) {
                <label for="ratingMovies"
                       i18n>None</label>
              }
            }
          }
        </td>
        <td>
          The maximum level of movie content allowed on the device. Available in iOS 4 and later, and tvOS 11.3 and
          later.<br />
          Possible values (with the US description of the rating level):<br />
          <br />
          1000: All<br />
          500: NC-17<br />
          400: R<br />
          300: PG-13<br />
          200: PG<br />
          100: G<br />
          0: None<br />
          <small>Default: 1000</small><br />
          <small>Minimum Value: 0</small><br />
          <small>Maximum Value: 1000</small>
        </td>
      </tr>
      <tr id="ratingRegion">
        <th><label for="ratingRegion"
                 class="col-form-label"
                 i18n>Rating Region</label></th>
        <td class="align-middle">
          @if (editing) {
            <select id="ratingRegion"
                    class="form-select"
                    formControlName="ratingRegion">
              <option value=""
                      selected
                      hidden>Choose here</option>
              <option value="us">US</option>
              <option value="au">AU</option>
              <option value="ca">CA</option>
              <option value="de">DE</option>
              <option value="fr">FR</option>
              <option value="ie">IE</option>
              <option value="jp">JP</option>
              <option value="nz">NZ</option>
              <option value="gb">GB</option>
            </select>
          } @else {
            @switch (restrictionsProfile()?.ratingRegion) {
              @case ('us') {
                <label for="ratingRegion"
                       i18n>US</label>
              }
              @case ('au') {
                <label for="ratingRegion"
                       i18n>AU</label>
              }
              @case ('ca') {
                <label for="ratingRegion"
                       i18n>CA</label>
              }
              @case ('de') {
                <label for="ratingRegion"
                       i18n>DE</label>
              }
              @case ('fr') {
                <label for="ratingRegion"
                       i18n>FR</label>
              }
              @case ('ie') {
                <label for="ratingRegion"
                       i18n>IE</label>
              }
              @case ('jp') {
                <label for="ratingRegion"
                       i18n>JP</label>
              }
              @case ('nz') {
                <label for="ratingRegion"
                       i18n>NZ</label>
              }
              @case ('gb') {
                <label for="ratingRegion"
                       i18n>GB</label>
              }
            }
          }
        </td>
        <td>
          The two-letter key that profile tools use to display the proper ratings for the given region. This data isn't
          recognized or reported by the client.<br />
          <small>Possible values: us, au, ca, de, fr, ie, jp, nz, gb</small>
        </td>
      </tr>
      <tr id="ratingTVShows">
        <th><label for="ratingTVShows"
                 class="col-form-label"
                 i18n>Rating TV Shows</label></th>
        <td class="align-middle">
          @if (editing) {
            <select class="form-select"
                    id="ratingTVShows"
                    formControlName="ratingTVShows">
              <option value=""
                      selected
                      hidden>Choose here</option>
              <option value="1000">All</option>
              <option value="600">TV-MA</option>
              <option value="500">TV-14</option>
              <option value="400">TV-PG</option>
              <option value="300">TV-G</option>
              <option value="200">TV-Y7</option>
              <option value="100">TV-Y</option>
              <option value="0">None</option>
            </select>
          } @else {
            @switch (restrictionsProfile()?.ratingTVShows) {
              @case (1000) {
                <label for="ratingTVShows"
                       i18n>All</label>
              }
              @case (600) {
                <label for="ratingTVShows"
                       i18n>TV-MA</label>
              }
              @case (500) {
                <label for="ratingTVShows"
                       i18n>TV-14</label>
              }
              @case (400) {
                <label for="ratingTVShows"
                       i18n>TV-PG</label>
              }
              @case (300) {
                <label for="ratingTVShows"
                       i18n>TV-G</label>
              }
              @case (200) {
                <label for="ratingTVShows"
                       i18n>TV-Y7</label>
              }
              @case (100) {
                <label for="ratingTVShows"
                       i18n>TV-Y</label>
              }
              @case (0) {
                <label for="ratingTVShows"
                       i18n>None</label>
              }
            }
          }
        </td>
        <td>
          The maximum level of TV content allowed on the device. Available in iOS 4 and later, and tvOS 11.3 and
          later.<br />
          Possible values (with the US description of the rating level):<br />

          1000: All<br />
          600: TV-MA<br />
          500: TV-14<br />
          400: TV-PG<br />
          300: TV-G<br />
          200: TV-Y7<br />
          100: TV-Y<br />
          0: None<br />
          <small>Default: 1000</small><br />
          <small>Minimum Value: 0</small><br />
          <small>Maximum Value: 1000</small>
        </td>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, copy and paste functionality respects the allowOpenFromManagedToUnmanaged and allowOpenFromUnmanagedToManaged restrictions. Also available for user enrollment.
      <br><small>Default: false</small>"
          id="requireManagedPasteboard"
          label="Require Managed Pasteboard">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.requireManagedPasteboard"></ml-yes-no-icon>
      </tr>
      <tr>
        <th><label for="safariAcceptCookies"
                 class="col-form-label">Safari Accept Cookies</label></th>
        <td class="align-middle">
          @if (editing) {
            <select class="form-select"
                    id="safariAcceptCookies"
                    formControlName="safariAcceptCookies">
              <option value=""
                      selected
                      hidden>Choose here</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="1.5">1.5</option>
              <option value="2">2</option>
            </select>
          } @else {
            {{ restrictionsProfile()?.safariAcceptCookies }}
          }
        </td>
        <td>
          This value defines the conditions under which the device accepts cookies. The user-facing settings changed in
          iOS 11, although the possible values remain the same. Available in iOS 4 and later.<br />
          <br />
          0: Prevent Cross-Site Tracking and Block All Cookies are enabled and the user can't disable either
          setting.<br />
          1 or 1.5: Prevent Cross-Site Tracking is enabled and the user can't disable it. Block All Cookies is not
          enabled, although the user can enable it.<br />
          2: Prevent Cross-Site Tracking is enabled and Block All Cookies is not enabled. The user can toggle either
          setting.<br />
          <br />
          <small>Default: 2</small><br />
          <small>Possible values: 0, 1, 1.5, 2</small>
        </td>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, disables Safari AutoFill for passwords, contact info, and credit cards and also prevents the Keychain from being used for AutoFill. Though third-party password managers are allowed and apps can use AutoFill.
        As of iOS 13, requires a supervised device. Available in iOS 4 and later, and macOS 10.13 and later.<br><small>Default: true</small>"
          id="safariAllowAutoFill"
          label="Safari Allow Auto Fill">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.safariAllowAutoFill"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, Safari doesn't execute JavaScript. Available in iOS 4 and later.<br><small>Default: true</small>"
          id="safariAllowJavaScript"
          label="Safari Allow Java Script">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.safariAllowJavaScript"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If false, Safari doesn't allow pop-up windows. Available in iOS 4 and later.<br><small>Default: true</small>"
          id="safariAllowPopups"
          label="Safari Allow Popups">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.safariAllowPopups"></ml-yes-no-icon>
      </tr>
      <tr row-checkbox
          [editing]="editing"
          description="If true, enables Safari fraud warning. Available in iOS 4 and later. Also available for user enrollment. <br><small>Default: false</small>"
          id="safariForceFraudWarning"
          label="Safari Force Fraud Warning">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.safariForceFraudWarning"></ml-yes-no-icon>
      </tr>

      <tr row-checkbox
          [editing]="editing"
          description="<br><small>Default: true</small>"
          id="allowMailPrivacyProtection"
          label="Allow Mail Privacy Protection">
        <ml-yes-no-icon [flag]="restrictionsProfile()?.allowMailPrivacyProtection"></ml-yes-no-icon>
      </tr>
    </tbody>
  </table>
</form>